import { createTheme } from '@mui/material'
import { CustomPalette } from './theme'

const { palette } = createTheme()
const { augmentColor } = palette
const createColor = (mainColor: string) => augmentColor({ color: { main: mainColor } })

const Palette_Light: CustomPalette = {
    termCondition: '#898989',
    formInput: {
        border: {
            error: 'red',
        },
    },
    input: {
        boxShadow: '0 0 0 100px white inset',
        border: '#898989',
    },
    promoTile: {
        text: '#000000',
    },
    process: {
        bar: 'lightgray',
    },
    carousel: {
        navBtn: {
            bgColor: '#ffffff',
            broderColor: '#999999',
        },
    },
    nav: {
        topBgColor: '#000000',
        sideBgColor: '#d8d8d8',
        btnHover: '#f2f3f5',
        sideTitleTx: '#5a5353',
        sideItemTx: '#5a5353',
        topTx: '#000000',
        navUserIcon: '#5a5353',
        navSideIcon: '#5a5353',
        cartIcon: '#ffffff',
    },
    payment: {
        bgHover: 'rgb(25, 90, 137)',
        bgSelected: 'rgb(36, 129, 196)',
    },
    calendar: {
        bgColor: '#ffffff',
        btnColor: '#2481c4',
    },
    modal: {
        bgColor: '#ffffff',
        inputBgColor: '#ffffff',
        closeBtn: {
            bgColor: '#ffffff',
            borderColor: '#484646',
        },
        dividerColor: '#494949',
    },
    menu: {
        bgColor: '#ffffff',
        headerBg: '#f4f6f8',
        headerTxt: '#000000',
    },
    fileUploader: {
        bgColor: 'white',
        circleBg: '#b3b1b1',
        svgBg: '#c6c9ce',
        outerTxt: '#c6c9ce',
    },
    footer: {
        bgColor: '#1c1c1c',
    },
    orderSummary: {
        summaryBg: '#ffffff',
        checkoutBtnBg: '#2481c3',
    },
    pageBanner: {
        bgColor: '#1c1c1c',
    },
    productCard: {
        bgColor: '#ffffff',
        postBg: 'red',
    },
    text: {
        primary: '#000000',
        secondary: '#c7c7c7',
        disabled: '#9b9b9b',
    },
    evoucherTemplate: {
        bgColor: '#FFFFFF',
        bannerBg: '#808080',
        headerBg: '#000000',
        txt: {
            primary: '#000000',
            secondary: '#808080',
        },
    },
    border: {
        default: '#898989',
        primary: '#000000',
        secondary: '#000000',
        focused: '#90caf9',
    },
    stepContainerUI: {
        border: {
            secondary: '#898989',
            default: '#323232',
        },
    },
    promoCarousel: {
        imgBg: '#2f3033',
    },
    table: {
        headerBg: '#f4f6f8',
        actionIcon: '#3b3b3b',
    },
    stepper: {
        bgColor: '#272727',
        lableComplete: '#19aa59',
    },
    assignAddCSV: {
        uploadBtnBg: '#3381c4',
        docInputBg: '#ffffff',
        border: '#515151',
    },
    shoppingCart: {
        itemHeader: '#1f1f1f',
    },
    actionMenu: {
        bgColor: '#f1f1f1',
    },
    carouse: {
        btn: '#1f1f1f',
        indicator: {
            primary: 'gray',
            secondary: 'lightgray',
        },
    },
    background: {
        default: '#ffffff',
        secondary: '#ededed',
        reverse: '#000000',
    },
    line: {
        bgColor: '#535353',
    },
    btn: {
        pill: { border: '#515354' },
    },
    link: {
        primary: '#2f78fd',
    },
    summary: {
        text: '#898989',
    },
    divider: '#2f3033',
    logoUrl: 'https://cdn.eventcinemas.com.au/cdn/giftshop/content/img/corporate/logo-white.svg',
    footerUrl: 'https://cdn.eventcinemas.com.au/cdn/giftshop/content/img/corporate/footer-icons.png',
    btnPrimary: createColor('#2481c4'),
    discountedPrice: 'green',
    homeLeftStripesUrl: 'https://cdn.eventcinemas.com.au/cdn/giftshop/content/img/corporate/left-side-stripes.svg',
    homeRightStripesUrl: 'https://cdn.eventcinemas.com.au/cdn/giftshop/content/img/corporate/right-side-stripes.svg',
}

export const MuiComponents_Light = {
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    color: 'white',
                    '&.Mui-disabled': {
                        color: 'lightgray',
                        backgroundColor: 'gray',
                        cursor: 'not-allowed',
                        pointerEvents: 'unset',
                    },
                },
            },
        },
        MuiCssBaseline: {
            styleOverrides: {
                '@font-face': {
                    fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
                },
            },
        },
    },
}

export default Palette_Light
